import React from 'react';
import classes from "../styles/Login.module.css";
import Input from "./Input/Input";
import Button from "./Button/Button";
import {BUTTON_TYPES} from "./Button/buttonTypes";
import {Link} from "react-router-dom";
import Spinner from "./Spinner/Spinner";

const ForgotPasswordComponent = ({email, loading, onChange, onBlur, onSubmit, status}) => {
  return (
      <div>
        <div className={classes.Email}>
          <Input
              name='email'
              label='Email'
              id='email'
              placeholder='Enter your email'
              value={email.value}
              onChange={onChange}
              onBlur={onBlur}
              error={email.touched && !email.valid}
          />
          <div className={classes.Button}>
            <Button
                type={BUTTON_TYPES.PRIMARY}
                onClick={onSubmit}
                disabled={loading}
            >
              {loading ? <Spinner /> : 'Forgot password'}
            </Button>
          </div>
          {status.description
            ?
              <div className={`${classes.responceText} ${status.isError ? classes.error : classes.success}`}>
                {status.description}
              </div>
            : null
          }
          <div className={classes.Registry}>
            <span>Have you remembered your password?</span>
            <Link to='/' className={classes.RegistryLink}>Sign in</Link>
          </div>
        </div>
      </div>
  );
};

export default ForgotPasswordComponent;